import React from 'react';
import { Trans, useTranslation } from 'react-i18next'; 
import './UbicacionPage.css';


import ubicacionHero from '../../../../assets/ubicacion-hero.png';
import puntaMosquitoAward from '../../../../assets/punta-mosquito-award.png';

const UbicacionPage: React.FC = () => {
  
  const { t } = useTranslation();

  return (
    <div className="ubicacion-page-container">
      {/* --- 1. Hero Section --- */}
      <header
        className="ubicacion-hero"
        style={{ backgroundImage: `url(${ubicacionHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">
          <Trans i18nKey="location:title" />
        </h1>
      </header>

      {/* --- 2. Intro Section (Negra) --- */}
      <section className="ubicacion-intro-black">
        <h2 className="intro-title">
          <Trans i18nKey="location:intro.title" />
        </h2>
        <p className="intro-subtitle">
          
          <Trans i18nKey="location:intro.subtitle" />
        </p>
      </section>

      {/* --- 3. Mapa Section --- */}
      <section className="mapa-section">
        <h2 className="mapa-title">
          <Trans i18nKey="location:map.title" />
        </h2>
        <div className="mapa-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3711.368917510937!2d-87.36887282490453!3d21.532425480245955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85f10654abf05289%3A0x93d3b34ca61f38ff!2sHotel%20Villas%20Flamingos%20Holbox!5e0!3m2!1ses-419!2smx!4v1763783957823!5m2!1ses-419!2smx"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={t('location:map.iframeTitle')}
          />
        </div>
      </section>

      <div className="page-divider"></div>

      {/* --- 5. Punta Mosquito Section --- */}
      <section className="punta-mosquito-section">
        <div className="punta-mosquito-grid">
          <div className="punta-mosquito-image">
            <img
              src={puntaMosquitoAward}
              alt={t('location:puntaMosquito.alt')}
            />
          </div>

          <div className="punta-mosquito-content">
            <div className="punta-mosquito-text">
              <h3>
                <Trans i18nKey="location:puntaMosquito.title" />
              </h3>
              <p>
                <Trans 
                  i18nKey="location:puntaMosquito.description" 
                  components={{ strong: <strong /> }}
                />
              </p>
            </div>

            <div className="punta-mosquito-cta">
              <p>
                <Trans 
                  i18nKey="location:puntaMosquito.cta"
                  components={{ 
                    strong: <strong />, 
                    br: <br />, 
                    highlight: <span className="cta-highlight" /> 
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UbicacionPage;